module.exports = __webpack_public_path__ + "assets/upload.9ac47846.svg";